import * as $ from 'jquery';
import { CountdownTimer, TickEvent } from "./countdowntimer";

export class Lesson {
    isTimerDone: boolean;
    totalLessonSeconds: number;
    offsetLessonSeconds: number; // if we're mid-lesson... just continue
    timer: CountdownTimer;
    pislid: number; // PurchaseItemSchoolLessonID
    piid: number;
    elapsedTimeSaved: boolean;
    $counttimer: JQuery;
    $pageseconds: JQuery;
    audioplayer: HTMLAudioElement;

    constructor(pislid: number, piid: number) {
        this.isTimerDone = true;
        this.pislid = pislid;
        this.piid = piid;
        this.$counttimer = $('#counttimer');
        this.$pageseconds = $('#PageSecondsElapsed');
        const self = this;

        this.audioplayer = document.getElementById("readalongplayer") as HTMLAudioElement;

        window.addEventListener("contextmenu", e => e.preventDefault());

        if (this.audioplayer) {
            const oldvolume = window.localStorage.getItem("audiovolume");
            if (oldvolume) {
                this.audioplayer.volume = parseFloat(oldvolume);
            }
            this.audioplayer.addEventListener("volumechange", () => self.audiovolumechange());
        }
    }

    // Monitor a change in audio volume and keep it for future use
    audiovolumechange() {
        window.localStorage.setItem("audiovolume", this.audioplayer.volume.toString());
    }

    startTimer(lessonseconds: number, offsetLessonSeconds: number) {
        const self = this;
        this.isTimerDone = true;
        this.elapsedTimeSaved = false;
        this.totalLessonSeconds = lessonseconds;
        if (offsetLessonSeconds) {
            this.offsetLessonSeconds = offsetLessonSeconds;
        }
        else {
            this.offsetLessonSeconds = 0;
        }
        // start the timer!
        if (this.totalLessonSeconds > 0) {
            this.timer = new CountdownTimer();
            this.timer.on("tick", tevent => self.tick(tevent));
            this.timer.on("expired", () => self.timerDone());
            this.isTimerDone = false;
            this.timer.startTimer(this.totalLessonSeconds - this.offsetLessonSeconds);
        }
        else {
            self.timerDone();
        }
        $('#finishlesson').on("click", function () {
            if (self.isTimerDone) {
                return true;
            }
            else {
                if (confirm("You still need to spend some time on this page. Are you sure you want to stop?")) {
                    // stuff the elapsed time in a variable so that we can record this information
                    self.saveElapsedTime();
                    window.location.href = "/Member/Summary/" + self.piid;
                    return false;
                }
                else {
                    return false;
                }
            }
        });
        // get all the links and add the timer warning
        $('a').on("click", function () {
            // special case links we don't ask anything
            if ($(this).hasClass("readalonglink")) {
                self.saveElapsedTime();
                return true;
            }
            if (self.isTimerDone) {
                if (confirm("If you exit this page without clicking the FINISH PAGE, you will have to repeat the lesson from the beginning. Are you sure you want to exit this page?")) {
                    self.saveElapsedTime();
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if (confirm("If you exit this page without letting the timer elapse, you will have to repeat the lesson from the beginning. Are you sure you want to exit this page?")) {
                    self.saveElapsedTime();
                    // stuff the elapsed time in a variable so that we can record this information
                    return true;
                }
                else {
                    return false;
                }
            }
        });
    }

    saveElapsedTime() {
        if (this.isTimerDone || this.elapsedTimeSaved) {
            return;
        }

        this.elapsedTimeSaved = true; // so we don't hit this again

        let data = new FormData();

        data.append('purchaseItemID', this.piid.toString());
        data.append('seconds', (this.timer.getSecondsElapsed() + this.offsetLessonSeconds).toString());
        data.append('purchaseItemSchoolLessonID', this.pislid.toString());

        if (navigator.sendBeacon) {
            navigator.sendBeacon("/Lesson/UpdateLessonTime", data)
        }
    }

    timerDone() {
        this.$counttimer.hide();
        $('#countdone').show();
        this.$pageseconds.val(-1);// full time elapse
        this.isTimerDone = true;
    }

    private tick(evt: TickEvent) {
        const formattedSeconds = CountdownTimer.getFormattedTime(evt.secondsLeft);
        this.$counttimer.text(formattedSeconds);
        this.$pageseconds.val(this.timer.getSecondsElapsed());
    }

    // Calculate greatest common demoninator for aspect ratio
    static gcd_rec(a: number, b: number): number {
        if (b) {
            return Lesson.gcd_rec(b, a % b);
        } else {
            return Math.abs(a);
        }
    }

    static getaspectratio(width: number, height: number): string {
        const gcd = Lesson.gcd_rec(width, height);
        return `${(width / gcd)} : ${(height / gcd)}`;
    }

    showMedia(medialist) {
        return;
        // we used to add some javascript for each type of media item. Now no longer necessary
    }
}
